import { apiMethodsConst } from '~/services/methods';
import { IReceiptReducerState, TReceiptAction } from './interface';
import { CLEAR_RECEIPTS_CSV_REPORT_V2 } from '~/actions';

export const initialState: IReceiptReducerState = {
  receipts: {
    data: [],
    metadata: {
      isFinal: false,
      limit: 0,
      officeIds: [],
      page: 0,
      sortBy: undefined,
      sortOrder: undefined,
      total: 0,
      transactionDate: '',
    },
  },
  reports: '',
};

export default (state = initialState, action: TReceiptAction): IReceiptReducerState => {
  const { type, payload } = action;

  switch (type) {
    case 'FETCH_RECEIPTS_V2_REQUEST': {
      return {
        ...state,
        receipts: {
          ...state.receipts,
          metadata: {
            ...state.receipts.metadata,
            limit: payload?.limit || 10,
            page: payload?.page || 1,
            officeIds: payload.officeId,
            sortBy: payload.sortBy,
            sortOrder: payload.sortOrder,
            transactionDate: payload.transactionDate,
          },
        },
      };
    }
    case apiMethodsConst.FETCH_RECEIPTS_V2_REQUEST: {
      const isFirstPage = payload?.page === 1;

      const receipts = isFirstPage
        ? payload.response
        : [...state.receipts.data, ...payload.response];

      const isFinal =
        payload.response.length === 0 ||
        payload.response.length < state.receipts.metadata.limit ||
        receipts.length === payload.total;

      return {
        ...state,
        receipts: {
          data: receipts,
          metadata: {
            ...state.receipts.metadata,
            total: payload.total,
            isFinal,
          },
        },
      };
    }
    case apiMethodsConst.FETCH_RECEIPTS_CSV_REPORT_V2_REQUEST: {
      return {
        ...state,
        reports: payload,
      };
    }
    case CLEAR_RECEIPTS_CSV_REPORT_V2: {
      return {
        ...state,
        reports: '',
      };
    }
    default: {
      return { ...state };
    }
  }
};
